import React from 'react';
import NavBar from '../../../components/common/navbar';
import SideBar from '../../../components/modules/left_sidebar';
import { withRouter } from 'react-router-dom';
import Common from './Common';
import { Button } from '@progress/kendo-react-buttons'
import services from '../../../services';
import Footer from '../../../components/common/Footer';
// import EntityDetails from '../../../components/common/EntityDetails';
// import $ from 'jquery'
// import RightPopModalForm from '../../../components/common/RightPopModalForm';
// import services from '../../../services';
const queryString = require('query-string');
const Administration = false;

/* Array de configurações estáticas da página*/
const optionMenuArray =
{
    linkData: {
        filters: {
            Tabs: {
                "Entreposto": [
                    {
                        key: 'NomeEntreposto',
                        displayKey: "Entreposto",
                        inputType: "dropdown"
                    }
                ],
                Localização: [
                    {
                        key: 'DICOFRE',
                        displayKey: "DICOFRE",
                        inputType: "locationDropDowns"
                    }
                ],
                // "Tipo de instalação": [
                //     {
                //         key: 'Tipo de instalação',
                //         displayKey: "Tipo de instalação",
                //         inputType: "dropdown",
                //         option:[]
                //     }
                // ],
                "Geocódigo": [
                    {
                        key: 'Geocódigo',
                        displayKey: "Geocódigo",
                        inputType: "text"
                    }
                ],
                "Estado": [
                    {
                        key: 'Estado',
                        displayKey: "Estado",
                        inputType: "dropdown",
                        option:[]
                    }
                ],
                "Agente económico": [
                    {
                        key: 'nome',
                        displayKey: "Nome",
                        inputType: "text"
                    },
                    {
                        key: 'entityType',
                        displayKey: "Número",
                        inputType: "text"
                    }
                ],
                Data: [
                    {
                        key: 'RangePickerVinicaCreation',
                        displayKey: "Data de Criação",
                        inputType: "RangePicker"
                    },
                    {
                        key: 'RangePickerVinicaModification',
                        displayKey: "Data de última atualização",
                        inputType: "RangePicker"
                    }
                ]
            },
            checkbox: []
        },
        navbarOptionsYear: false,
        tableName: "Instalações",
        nevdropdown: ["Abertura", "Fecho"],
        nevdroplabel: "",
        nevdropplaceholder: "Aberta",
        // OpenAndCloseCashier: true,
        TitleBartitle: "Instalações Vínicas",
        prevPageName: "",
        prevPageLink: "",
        currentPath: "revenue_receitas",
        popUpTabName: "Consultar Conta",
        nevOptionChange: [],
        FormInsertPath: "instalaçõesinsert",
        TitleBarlogo: "instalacoesvinicas",
    }
}

let defaultRequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};


class InstalaCaovinica extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        //this.getTipoInstalacao();
        this.getEntreposto();
        this.getEstadoList()
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = () => {
        const parsed = queryString.parse(this.props.location.search);
        if (!parsed.t || this.state.search !== window.location.search || this.state.tableName !== parsed.t) {
            this.setLinkDataMethod()
        }
    }

    getTipoInstalacao = async () => {
        let res = await services.apiCall.requestApi('allservice/TipoInstalacao',defaultRequest,'post')
        if(res && res.length > 0){
            let {filters} = {...optionMenuArray.linkData}
            let options = [];
            res.map((row)=>{
                options.push({key : row.tipoInstalacao,value:row.tipoInstalacao})
            })
            filters['Tabs']['Tipo de instalação'][0].option = options
        }
    }
    getEntreposto = async () => {
        let res = await services.apiCall.requestApi('allservice/EntrepostoDropdown/GetAll',defaultRequest,'post')
        if(res && res.length > 0){
            console.log("spiderman entreposto ", res)
            let {filters} = {...optionMenuArray.linkData}
            let options = [];
            res.map((row)=>{
                options.push({key : row.nomeEntreposto, value:row.nomeEntreposto})
            })
            filters['Tabs']['Entreposto'][0].option = options
        }
    }

    getEstadoList = async () => {
        //let res = await services.apiCall.requestApi('allservice/InstalacaoVinicaEstado/GetAll',defaultRequest,'post')
        let options = [];
        let {filters} = {...optionMenuArray.linkData}
        // if(res && res.length > 0){
        //     console.log("Estado options.... ", res)
            
        //     res.map((row)=>{
        //         options.push({key : row.estado,value:row.estado})
        //     })
        // }

        //added new 
        options.push({key : "Avtivo",value:"Ativo"})
        options.push({key : "Inavtivo",value:"Inativo"})
        filters['Tabs']['Estado'][0].option = options
    }


    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */

    setLinkDataMethod = () => {
        const parsed = queryString.parse(this.props.location.search);
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.p) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = "Instalações"
        }
        parsed.p = parsed.p ? parsed.p : ""
        parsed.u = parsed.u ? parsed.u : ""
        parsed.t = parsed.t ? parsed.t : ""
        if (parsed.p) {
            linkData.prevPageName = parsed.p;
            linkData.prevPageLink = parsed.u;
            linkData.tableName = parsed.t;
        }

        return {
            nevoption: null,
            popUpForm: null,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed,
            tableName: linkData.tableName,
            search: window.location.search
        }
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("OKOKOKO");
        return (
            <div className="dashboard">
                <NavBar date={ new Date() } linkData={ this.state.linkData } nevoption={ this.state.nevoption } />
                <SideBar Administration={ Administration } />
                <div className="container-fluid">
                    <Common
                        date={ new Date() }
                        parsed={ this.state.parsed }
                        optionMenuArray={ optionMenuArray }
                        linkData={ this.state.linkData }
                        trans_methods={ this.state.trans_methods }
                        tab={ "Revenue_receitas" }
                    />
                </div>
                <Footer/>
            </div>

        )
    }
}


export default withRouter(InstalaCaovinica);
